export const DOTS_WINDOW_SIZE = 5;

export type DotVariant = 'active' | 'default' | 'edge';

type GetDotsWindowStartParams = {
  total: number;
  selectedIndex: number;
  windowSize?: number;
};

type GetDotVariantParams = {
  index: number;
  selectedIndex: number;
  windowStart: number;
  total: number;
  windowSize?: number;
};

export const getDotsWindowStart = ({
  total,
  selectedIndex,
  windowSize = DOTS_WINDOW_SIZE,
}: GetDotsWindowStartParams) => {
  const lastPossibleStart = total - windowSize;

  if (lastPossibleStart <= 0) return 0;

  const centeredStart = selectedIndex - Math.floor(windowSize / 2);

  return Math.min(Math.max(centeredStart, 0), lastPossibleStart);
};

export const getDotVariant = ({
  index,
  selectedIndex,
  windowStart,
  total,
  windowSize = DOTS_WINDOW_SIZE,
}: GetDotVariantParams): DotVariant => {
  if (index === selectedIndex) return 'active';

  const windowEnd = windowStart + windowSize - 1;
  const hasSlidesBefore = windowStart > 0;
  const hasSlidesAfter = windowEnd < total - 1;

  if (index === windowStart && hasSlidesBefore) return 'edge';
  if (index === windowEnd && hasSlidesAfter) return 'edge';

  return 'default';
};
